import { render, staticRenderFns } from "./coming.vue?vue&type=template&id=a2584052&"
import script from "./coming.vue?vue&type=script&lang=js&"
export * from "./coming.vue?vue&type=script&lang=js&"
import style0 from "./coming.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports